import { ShowSection } from 'framework/ui/layout';
import DavinciReportForm from './DavinciReportForm';
import { useParams } from 'react-router-dom';
import { useNewProjectUrl } from 'domain/shared/newProject';
import { CreateForm } from 'framework/form';
import useCustomerReportService from '../useCustomerReportService';
import CustomerReportActionButtons from './CustomerReportActionButtons';
import { useProjectDetails } from 'domain/projects/newProject/dashboard/hooks/useProjectDashboard';

const UpdateCustomerReportLayout = () => {
  const { id, reportId } = useParams();
  const { getCustomerReportUrl } = useNewProjectUrl();
  const { updateDraftReport, getCustomerReportById, submitCustomerReport, getCustomerReportValidationSchema } =
    useCustomerReportService();
  const { project } = useProjectDetails(id!);
  const reportFrequency = project?.settings?.reportSettings?.reportFrequency;
  const projectStartDate = project?.health?.createdAt;

  const submitPayload = (values: any) => ({
    id: values.id,
    periodStart: values.periodStart,
    periodEnd: values.periodEnd,
    template: values.template,
    businessOutcomes: values.businessOutcomes,
    milestones: values.milestones,
    risks: values.risks,
    changeRequests: values.changeRequests,
    projectId: id,
  });

  return (
    <CreateForm
      getDataFunc={() => getCustomerReportById(reportId!, {})}
      submitFormFunc={async values =>
        values.isDraft
          ? updateDraftReport(reportId!, submitPayload(values))
          : submitCustomerReport(id!, submitPayload(values))
      }
      afterSubmit={{
        redirect: getCustomerReportUrl(id),
        message: 'You are awesome! Customer Report has been successfully updated.',
      }}
      getValidationSchemaFunc={getCustomerReportValidationSchema}
    >
      <ShowSection title="Update Customer Report:" titleVariant="h2">
        <DavinciReportForm projectId={id!} reportFrequency={reportFrequency} projectStartDate={projectStartDate} />
        <CustomerReportActionButtons approvalType={project?.settings?.reportSettings?.approvalType} />
      </ShowSection>
    </CreateForm>
  );
};
export default UpdateCustomerReportLayout;
